const FoodData = [
    {
        id : "1",
        schemeName: "Pradhan Mantri Kisan Sampada Yojana.",
        discription:"PM Kisan SAMPADA Yojana is a comprehensive package which will result in creation of modern infrastructure with efficient supply chain management from farm gate to retail outlet. It will not only provide a big boost to the growth of food processing sector in the country but also help in providing better returns to farmers and is a big step towards doubling of farmers income, creating huge employment opportunities especially in the rural areas, reducing wastage of agricultural produce, increasing the processing level and enhancing the export of the processed foods..",
        launchDate: "24 February 2019",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Operations Green",
    discription:"In the budget speech of 2018-19, a new Scheme “Operation Greens” was announced on the line of “Operation Flood”, with an outlay of Rs. 500 crore to promote Farmer Producers Organizations, agri-logistics, processing facilities and professional management.",
    launchDate: "Novemember 2018",
    AnualFund: "12345"},
]

export default FoodData